import { ErrorMessage,  useFormikContext } from "formik";
import { CardBody, CardHeader, Col, FormGroup, Row } from "reactstrap";
import organizationData from "../../../utils/organizationData.json";
import { useState } from "react";
import { OrganizationFormData } from "../../../types/organization/OrganizationTypes";
import ReactDatePicker from "react-datepicker";
// import Select from "react-select";
import { customReactSelectStyles } from "../../../styles/ReactSelectStyles";
import { useTranslation } from "react-i18next";
import VariationOfSwitchOne from "../../forms/forms-widgets/switch/variation-of-switches/VariationOfSwitchOne";
import { switchAccountType } from "../../../data/forms/forms-control/forms-widgets/switch/Switch";
import {Typeahead} from "react-bootstrap-typeahead";


interface SubscriptionDetailsSectionProps {
  isEdit?: boolean;
}

const SubscriptionDetailsSection = ({ isEdit }: SubscriptionDetailsSectionProps) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext<OrganizationFormData>();

  // End date for subscription plan (Default 1 month from today )
  const [endDate, setEndDate] = useState<Date | null>(() => {
    const today = new Date();
    const nextMonth = new Date(today);
    nextMonth.setMonth(today.getMonth() + 1);
    return nextMonth;
  });

  return (
    <div className="mb-4">
      <CardHeader>
        <h5>{t("SubscriptionDetails")}</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationSubscriptionPlan")}</label>
              <Typeahead
                id="subscription-plan-typeahead"
                labelKey="label"
                options={organizationData.subscriptionTypes}
                placeholder={t("OrganizationSubscriptionPlanPlaceholder")}
                selected={
                  values.subscriptionType
                    ? organizationData.subscriptionTypes.filter(opt => opt.value === values.subscriptionType)
                    : []
                }
                onChange={selected => {
                  const plan = selected[0] as { value: string } | undefined;
                  setFieldValue('subscriptionType', plan ? plan.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="subscriptionPlan"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup className="d-flex flex-column align-items-stretch">
              <label >{t("ExpireyDate")} <span className="txt-danger">*</span></label>
              <ReactDatePicker
                className="datepicker-here form-control"
                selected={endDate}
                onChange={(date: Date | null) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup>
              <label>{t("Distributor")}</label>
              <Typeahead
                id="distributor-typeahead"
                labelKey="label"
                options={organizationData.distributors}
                placeholder={t("DistributorPlaceholder")}
                selected={
                  values.distributor
                    ? organizationData.distributors.filter(opt => opt.value === values.distributor)
                    : []
                }
                onChange={selected => {
                  const distributor = selected[0] as { value: string } | undefined;
                  setFieldValue('distributor', distributor ? distributor.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="distributor"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup>
              <label>{t("Franchises")}</label>
              <Typeahead
                id="franchises-typeahead"
                labelKey="label"
                options={organizationData.franchises}
                placeholder={t("FranchisesPlaceholder")}
                selected={
                  values.franchise
                    ? organizationData.franchises.filter(opt => opt.value === values.franchise)
                    : []
                }
                onChange={selected => {
                  const franchise = selected[0] as { value: string } | undefined;
                  setFieldValue('franchise', franchise ? franchise.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="franchises"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <VariationOfSwitchOne switchData={switchAccountType} />
          </Col>
        </Row>
      </CardBody>
    </div>
  );
};

export default SubscriptionDetailsSection; 